import React from 'react';
import { CTAButton } from './CTAButton';
import { kitRows, CHECKOUT_SISTEMA_COMPLETO } from '../data/content';
export function KitSection() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:px-5 sm:py-20" data-id="element-131" data-mp="1cylmvlfbvz6n">
      <div className="mx-auto max-w-5xl" data-id="element-132" data-mp="z4b6psheddc7">
        <h2 className="text-center text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-133" data-mp="1447aprq3h4rr">
          🚀 ¿Qué suma el Acelerador de Escala Nacional?
        </h2>

        <div className="mt-10 overflow-hidden rounded-3xl border border-white/10" data-id="element-134" data-mp="p5lotzpi3svy">
          <table className="hidden w-full border-collapse text-left md:table" data-id="element-135" data-mp="u7kph1tuwbp7">
            <thead data-id="element-136" data-mp="g79xtwkq2t2z">
              <tr className="bg-ink-700" data-id="element-137" data-mp="g7t6snsea74v">
                <th className="p-5 text-sm font-extrabold text-red-400" data-id="element-138" data-mp="l51q4rpa4h7p">
                  ❌ Sin Tomo 2
                </th>
                <th className="p-5 text-sm font-extrabold text-brand-500" data-id="element-139" data-mp="2ajztojunicd0">
                  ✅ Con Tomo 2
                </th>
              </tr>
            </thead>
            <tbody data-id="element-140" data-mp="r7x8qjhcpail">
              {kitRows.map(row => <tr key={row.without} className="border-t border-white/10" data-id="element-141" data-mp="r6dsgsvp2zgt">
                  <td className="bg-ink-800 p-5 text-sm text-gray-400" data-id="element-142" data-mp="n5ac859qj1f2">
                    {row.without}
                  </td>
                  <td className="bg-ink-800 p-5 text-sm font-semibold text-brand-400" data-id="element-143" data-mp="10wylm0slnbsc">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>

          <ul className="divide-y divide-white/10 md:hidden" data-id="element-144" data-mp="8b5i1ozhbt4i">
            {kitRows.map(row => <li key={row.without} className="bg-ink-800 p-5" data-id="element-145" data-mp="49k563my3eub">
                <p className="text-sm text-gray-400" data-id="element-146" data-mp="i81q5tlgud8j">
                  <span className="font-semibold text-red-400" data-id="element-147" data-mp="d8fdpmdgp10s">
                    ❌ Sin Tomo 2:
                  </span>{' '}
                  {row.without}
                </p>
                <p className="mt-2 text-sm text-brand-400" data-id="element-148" data-mp="1to8kacmx7aw1">
                  <span className="font-semibold" data-id="element-149" data-mp="1omj5clwkud2o">✅ Con Tomo 2:</span>{' '}
                  {row.with}
                </p>
              </li>)}
          </ul>
        </div>

        <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-brand-500/30 bg-ink-800 p-5 text-center sm:p-8" data-id="element-150" data-mp="20ou9f0rukji9">
          <p className="text-base font-extrabold text-white sm:text-lg" data-id="element-151" data-mp="25p883s7k6h3m">
            Por solo $8.000 ARS más, agregás el motor que alimenta todo el
            sistema.
          </p>
          <div className="mx-auto mt-6 max-w-md" data-id="element-152" data-mp="1d12l0yt18g0m">
            <CTAButton href={CHECKOUT_SISTEMA_COMPLETO} data-id="element-153" data-mp="1cy6qlkge89gx">
              → QUIERO EL SISTEMA COMPLETO
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}